import React from 'react'

import { Form, Button } from '_zari/core'

import { PlantillaCobranzaCrudModal } from 'sharedComponents/modals'

import * as PlantillaCobranzaService from 'services/plantillaCobranza.service'

const Select2ProveedorInput = ({ showNewButton, onChange, ...props }) => {
  const [mostrarPlantillaCobranzaCrudModal, setMostrarPlantillaCobranzaCrudModal] = React.useState(
    false
  )
  const [plantillas, setPlantillas] = React.useState([])

  React.useEffect(() => {
    PlantillaCobranzaService.getAsSelect()
      .then(({ data }) => setPlantillas(data))
      .catch(() => setPlantillas([]))
  }, [])

  const clickMostrarPlantillaCobranzaCrudModalHandler = React.useCallback(() => {
    setMostrarPlantillaCobranzaCrudModal(true)
  }, [])

  const handleClose = React.useCallback(() => {
    setMostrarPlantillaCobranzaCrudModal(false)
    PlantillaCobranzaService.getAsSelect()
      .then(({ data }) => setPlantillas(data))
      .catch(() => setPlantillas([]))
  }, [])

  const innerOnChange = React.useCallback(
    e => {
      if (onChange) {
        const found = plantillas.find(x => x._id === e.target.value)

        if (found) {
          onChange({
            ...e,
            moneda: found.moneda
          })
        } else {
          onChange({
            ...e,
            moneda: ''
          })
        }
      }
    },
    [onChange, plantillas]
  )

  return (
    <>
      {showNewButton ? (
        <Form.InputGroup>
          <Form.Select {...props} onChange={innerOnChange}>
            <option value=''>Seleccionar</option>
            {plantillas.map(x => (
              <option key={x._id} value={x._id}>
                {`(${x.moneda}) ${x.cuentaContable}`}
              </option>
            ))}
          </Form.Select>
          <Form.InputGroup.Append>
            <Button
              disabled={props.disabled}
              onClick={clickMostrarPlantillaCobranzaCrudModalHandler}
            >
              &#x2b;
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
      ) : (
        <Form.Select {...props} onChange={innerOnChange}>
          <option value=''>Seleccionar</option>
          {plantillas.map(x => (
            <option key={x._id} value={x._id}>
              {`(${x.moneda}) ${x.cuentaContable}`}
            </option>
          ))}
        </Form.Select>
      )}
      {mostrarPlantillaCobranzaCrudModal && (
        <PlantillaCobranzaCrudModal
          handleClose={handleClose}
          show={mostrarPlantillaCobranzaCrudModal}
        />
      )}
    </>
  )
}

export default React.memo(Select2ProveedorInput)
